import React from 'react';
import { Sparkles, Tag } from 'lucide-react';
import Link from 'next/link';
import NewArrivals from '@/components/sections/NewArrivals.jsx';

const DualPromoBanner = () => {
    return (
        <>
            {/* New Arrivals — mobile only */}
            <div className="block md:hidden">
                <NewArrivals />
            </div>
{/* Mobile Clearance Banner — full bleed, outside the padded container */}
<Link href="/clearance" className="block md:hidden relative overflow-hidden">
    <div className="relative bg-gradient-to-r from-[#7a4f3e] via-[#422c1f] to-[#815a4a] px-5 py-4">
        {/* Top shimmer line */}
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A86A]/70 to-transparent" />
        {/* Bottom shimmer line */}
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A86A]/40 to-transparent" />
        {/* Glow */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#C9A86A]/5 via-transparent to-[#C9A86A]/5 pointer-events-none" />

        <div className="relative flex items-center justify-between gap-3">
            {/* Left: icon + text */}
            <div className="flex items-center gap-3 min-w-0">
                <div className="relative bg-white/15 border border-white/30 p-2.5 rounded-xl flex-shrink-0">
                    <Tag className="h-5 w-5 text-white" strokeWidth={1.5} />
             
                </div>
                <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-white font-serif text-base tracking-wider whitespace-nowrap">
                            CLEARANCE SALE
                        </h3>
                   
                    </div>
                    <p className="text-white/60 text-xs mt-0.5">
                        Exceptional value on select pieces
                    </p>
                </div>
            </div>
            {/* Right: CTA */}
            <div className="flex-shrink-0 bg-white rounded-full px-4 py-1.5">
                <span className="text-[#1A0F08] text-xs font-bold whitespace-nowrap">
                    Shop →
                </span>
            </div>
        </div>
    </div>
</Link>
            {/* Desktop: original two-column banner */}
            <div className="hidden md:block w-full bg-[#FAF9F7] border-y border-[#E5E1DB]">
                <div className="mx-auto px-6 lg:px-16 py-1">
                    <div className="grid grid-cols-2 divide-x divide-[#E5E1DB]">

                        {/* New Arrivals - Left */}
                        <Link
                            href="/new-arrivals"
                            className="group relative overflow-hidden transition-all duration-500 hover:bg-[#F5F3EF]"
                        >
                            <div className="relative z-10 px-8 py-5 lg:px-12 lg:py-6">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-4">
                                        <div className="bg-[#8B7355]/10 p-3 rounded-full group-hover:bg-[#8B7355]/15 transition-all duration-300">
                                            <Sparkles className="h-5 w-5 lg:h-6 lg:w-6 text-[#8B7355]" strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-3 mb-1">
                                                <h3 className="text-[#8B7355] font-serif text-lg lg:text-xl tracking-wide">
                                                    NEW ARRIVALS
                                                </h3>
                                                <span className="hidden sm:inline-block bg-[#8B7355] text-white text-[10px] font-medium px-2.5 py-1 rounded-full uppercase tracking-widest">
                                                    Fresh
                                                </span>
                                            </div>
                                            <p className="text-[#6B5D52] text-xs lg:text-sm font-light">
                                                Discover our latest exquisite designs
                                            </p>
                                        </div>
                                    </div>
                                    <span className="text-[#8B7355] text-sm font-light group-hover:translate-x-1 transition-transform duration-300 inline-block">
                                        Explore →
                                    </span>
                                </div>
                            </div>
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out" />
                        </Link>

                        {/* Clearance Sale - Right */}
                        <Link
                            href="/clearance"
                            className="group relative overflow-hidden transition-all duration-500 hover:bg-[#F5F3EF]"
                        >
                            <div className="relative z-10 px-8 py-5 lg:px-12 lg:py-6">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-4">
                                        <div className="relative bg-[#A67C52]/10 p-3 rounded-full group-hover:bg-[#A67C52]/15 transition-all duration-300">
                                            <Tag className="h-5 w-5 lg:h-6 lg:w-6 text-[#A67C52]" strokeWidth={1.5} />
                                            <span className="absolute -top-1 -right-1 bg-[#C9A86A] text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full">
                                                SALE
                                            </span>
                                        </div>
                                        <div>
                                            <div className="flex items-center gap-3 mb-1">
                                                <h3 className="text-[#8B7355] font-serif text-lg lg:text-xl tracking-wide">
                                                    CLEARANCE SALE
                                                </h3>
                                                <span className="hidden sm:inline-block bg-[#A67C52] text-white text-[10px] font-medium px-2.5 py-1 rounded-full uppercase tracking-widest">
                                                    Up to 10% Off
                                                </span>
                                            </div>
                                            <p className="text-[#6B5D52] text-xs lg:text-sm font-light">
                                                Exceptional value on select pieces
                                            </p>
                                        </div>
                                    </div>
                                    <span className="text-[#A67C52] text-sm font-light group-hover:translate-x-1 transition-transform duration-300 inline-block">
                                        Shop Now →
                                    </span>
                                </div>
                            </div>
                            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-out" />
                        </Link>

                    </div>
                </div>
            </div>
        </>
    );
};

export default DualPromoBanner;